module.exports = __webpack_public_path__ + "static/media/rezaul-karim.f3576083.jpg";